import { render, staticRenderFns } from "./OsbodEventTeacherAddEdit.vue?vue&type=template&id=7003e068"
import script from "./OsbodEventTeacherAddEdit.vue?vue&type=script&lang=js"
export * from "./OsbodEventTeacherAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports